export function getScrollTop(element = null) {
  return element
    ? element.scrollTop
    : process.browser
      ? window?.pageYOffset
        || document?.documentElement?.scrollTop
        || document?.body?.scrollTop
        || 0
      : 0
}

export function getScrollTo() {
  return window.scrollTo
    || document.body.scrollTo
    || document.documentElement.scrollTo
    || (() => {})
}
